<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-7"> </p>
<p class="NT"><a id="_idTextAnchor000"></a>Revenge</p>
<p class="EPIunderNT">Revenge is a dish better served cold.</p>
<p class="EPIS">(Old Sicilian adage)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4481_eBook6.vue?10fe4780